export default __webpack_public_path__ + "static/media/student-mask.69abd9b0.png";